import { Component, input } from '@angular/core';
import { BarInputs } from '@charts';
import { BarChartComponent } from "../bar-chart";

@Component({
  selector: 'ui-rsabt-wave-quality-flicker-chart',
  imports: [BarChartComponent],
  template: ` <ui-bar-chart [barInputs]="barInputs()" /> `,
})
export class RsabtWaveQualityFlickerChartComponent {
  barInputs = input.required<BarInputs>();
}
